export const checkboxColors = {
  readOnly: 'sandstone.30',
  unchecked: 'sandstone.60',
  checked: 'seaBlue.28',
  hover: 'seaBlue.20',
  focus: 'seaBlue.35',
} as const

export const disabled = {
  icon: 'sandstone.79',
  text: 'sandstone.60',
} as const
